export default "__VITE_ASSET__B30a1hxG__"